import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";

export const SectionTwo = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const [flippedCards, setFlippedCards] = useState([]); // track flipped states

  const toggleFlip = (idx) => {
    setFlippedCards((prev) => {
      const newFlips = [...prev];
      newFlips[idx] = !newFlips[idx];
      return newFlips;
    });
  };

  const cardsData2 = [
    {
      icon: "assets/images/checkout-v-one/low.png",
      headline: "Low Conversions",
      contents: ["Missed revenue", "High CAC", "Poor ROAS"],
      onhover: {
        icon: "assets/images/checkout-v-one/bag.png",
        percent: "40%",
        title: "Higher conversions",
      },
    },
    {
      icon: "assets/images/checkout-v-one/high.png",
      headline: "High RTO on COD",
      contents: ["Inflated GMV", "Blocked Inventory", "Logistical losses"],
      onhover: {
        icon: "assets/images/checkout-v-one/box.png",
        percent: "40%",
        title: "RTO reduction",
      },
    },
    {
      icon: "assets/images/checkout-v-one/low2.png",
      headline: "Low Prepaid Orders",
      contents: ["Higher COD risk factor", "Delayed cash inflow"],
      onhover: {
        icon: "assets/images/checkout-v-one/card.png",
        percent: "25%",
        title: "COD to prepaid conversion",
      },
    },
  ];

  return (
    <div className="section-two-checkout">
      <div className="container-fluid">
        <div
          className="mid-text3-sec-two w-full md:w-6 mt-10"
          style={{ margin: isMobile ? "0px 0.2rem" : "0px 5rem" }}
        >
          <h1>Most brands know these problems</h1>
          <p style={{ color: "#fff" }}>The top 1% are solving them with us</p>
        </div>

        <div className="info-section-two-checkout">
          <div className="card-wrapper">
            {cardsData2.map((card, idx) => (
              <div
                className={`info-card-two-checkout ${
                  flippedCards[idx] ? "flipped" : ""
                }`}
                key={idx}
                onClick={() => isMobile && toggleFlip(idx)} // only this card flips
              >
                {/* Front side */}
                <div className="card-front">
                  <img
                    src={card.icon}
                    alt=""
                    className="info-icon1-c1"
                  
                  />
                  <p className="info-text-two-checkout">{card.headline}</p>
                  <ul>
                    {card.contents.map((item, i) => (
                      <li
                        className="items-sec-two"
                        style={{
                          color: "black",
                          fontSize: "24px",
                          fontFamily: "400",
                          marginTop: "10px",
                        }}
                        key={i}
                      >
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Back side */}
                <div className="card-back">
                  <img src={card.onhover.icon} alt="" className="info-icon1-c1" />
                  <h2 className="hover-percent">{card.onhover.percent}</h2>
                  <p className="hover-title">{card.onhover.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionTwo;
